import {ChangeDetectorRef, Component} from '@angular/core';
import {Store} from "@ngrx/store";
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {DatabaseService} from "@cosbeni/database";
import {GapiSession} from "../gapi/gapi.session";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Capability, canWith, CAPS} from "../services/roles";
import * as wjcCore from "@mescius/wijmo";

@Component({
    standalone: false,
    selector: 'app-admin-container',
    templateUrl: './admin-container.component.html'
})
export class AdminContainerComponent {
    database: string;
    user: any;
    isGoogleSignedIn: boolean = false;
    // テンプレートからケーパビリティ定数を参照するため公開する。
    readonly CAPS = CAPS;

    constructor(private store: Store<any>, private auth: AuthService, private databaseService: DatabaseService, private storage: StorageService, private config: ConfigService, private gapiSession: GapiSession, private cdRef:ChangeDetectorRef) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if(wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded){
                this.user = digitalAuction.user.user;
            }
        });
        this.database = this.storage.get("database");
    }

    logout() {
        this.auth.logout().subscribe(response => {
            console.log("LOGOUT SUCCESSFUL!!")
        });
        this.storage.remove(this.database + "_url");
    }

    googleSignIn() {
        this.gapiSession.signIn().then(() => {
            if (this.gapiSession.isSignedIn()) {
                this.isGoogleSignedIn = true;
                this.cdRef.detectChanges();
            }
        });
    }

    googleSignOut() {
        this.gapiSession.signOut();
        this.isGoogleSignedIn = false;
    }

    public hasRole(name: string): boolean {
        let result: boolean = false;
        if (wjcCore.isObject(this.user) && wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                if (role.name == name) {
                    result = true;
                }
            }
        }
        return result;
    }

    /** roles.ts のケーパビリティでメニュー可視性を判定する。 */
    public can(capability: Capability | Capability[]): boolean {
        return canWith(wjcCore.isObject(this.user) ? this.user.roles : null, capability);
    }

    public enableMenu(name: string): boolean {
        let result: boolean = true;
        if (this.user[name])
            result = false;
        return result;
    }
}
